export const MEETING_CATEGORIES = {
  EB: "EB",
  PBAC: "PBAC",
  WHA: "WHA",
  OTHER: "Other"
} as const;

export const INTERVENTION_MEETING_CATEGORIES = {
 /*  EB: "Executive Board Member", */
  NON_EB: "Non Executive Board Member"
} as const;

export type MeetingCategory = keyof typeof MEETING_CATEGORIES;

export const MEETING_STATUS = {
  FUTURE: "Future",
  ACTIVE: "Active",
  PAST: "Past"
} as const;

export type MeetingStatus = typeof MEETING_STATUS[keyof typeof MEETING_STATUS]; 